module.exports = __webpack_public_path__ + "static/media/school-outline--gray.9a3543ca.svg";